export default __webpack_public_path__ + "static/it-sigma-logo-4cf3a151c1a3a86e3944fb72790f0dce.png";